import script from "./Pets.vue?vue&type=script&setup=true&lang=js"
export * from "./Pets.vue?vue&type=script&setup=true&lang=js"

import "./Pets.vue?vue&type=style&index=0&id=9b92092c&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/pet/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9b92092c"]])

export default __exports__